import { NextSeo } from 'next-seo';
import Head from 'next/head';

//vendor
import { SegmentPixel, CapterraPixel } from 'vendor';

import { CarrierTMS } from '@/screens/CarrierTMS/CarrierTMS';

export default function CarrierTMSPage() {
  return (
    <>
      <Head>
        <meta
          name="keywords"
          content="truck management system, truck management software, trucking management software, trucking management system, trucking management solution, fleet management system, fleet management software, digital carrier platform, digital carrier software, tms, fleet management, Software for trucking business"
        />
      </Head>
      <NextSeo
        nofollow={process.env.NOINDEX_FLAG === 'true'}
        noindex={process.env.NOINDEX_FLAG === 'true'}
        title="Truck Management Software | Loadsmart"
        description="A truck management software (TMS) to help dispatchers optimize driver’s time on the road. Reducing back-office expenses and drive the profitability of your business."
        canonical="https://loadsmart.com/carrier/tms/"
        openGraph={{
          url: 'https://loadsmart.com/carrier/tms/',
        }}
      />
      <CarrierTMS />
      {process.env.NOINDEX_FLAG === 'true' ? '' : <SegmentPixel />}
      {process.env.NOINDEX_FLAG === 'true' ? '' : <CapterraPixel />}
    </>
  );
}
